export default "__VITE_ASSET__C4nmZj1o__"